if (!customElements.get("how-it-works")) {
  class HowItWorks extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onModalClosed = this.onModalClosed.bind(this);
    }

    connectedCallback() {
      this.addEventListener("click", this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this.onClick);
      if (this.unsubscribe) this.unsubscribe();
      if (this.modal && this.modal.modal.classList.contains("m-open-modal")) this.modal.close();
      this.unsubscribe = null;
      this.modal = null;
      this.lastTrigger = null;
    }

    onClick(event) {
      if (event.target.closest("a")) return;
      const trigger = event.target.closest("[data-video-popup]");
      if (!trigger || !this.contains(trigger)) return;

      event.preventDefault();
      this.openPopup(trigger);
    }

    getModal() {
      const Modal = window.MinimogTheme && window.MinimogTheme.Modal;
      if (!this.modal && Modal) {
        this.modal = new Modal();
        if (window.MinimogEvents) {
          this.unsubscribe = window.MinimogEvents.subscribe("ON_MODAL_CLOSED", this.onModalClosed);
        }
      }
      return this.modal;
    }

    openPopup(trigger) {
      const id = trigger.dataset.videoPopup;
      const template = Array.from(this.querySelectorAll("template[data-popup-template]")).find(
        (item) => item.dataset.popupTemplate === id
      );
      const modal = template && this.getModal();
      // The modal stays in the page until its closing transition ends, so wait for that.
      if (!modal || modal.modal.isConnected) return;

      modal.appendChild(template.content.firstElementChild.cloneNode(true));
      modal.setSizes(template.dataset.popupClasses);
      modal.modal.setAttribute("role", "dialog");
      modal.modal.setAttribute("aria-modal", "true");
      modal.modal.setAttribute("aria-label", template.dataset.popupLabel);
      this.lastTrigger = trigger.closest("button") || this.querySelector(`button[data-video-popup="${id}"]`);
      modal.open();

      setTimeout(() => {
        const close = modal.modal.querySelector(".m-modal--close");
        if (close) close.focus({ preventScroll: true });
      }, 250);
    }

    // The modal removes the popup (and stops its video) when it closes.
    onModalClosed(modal) {
      if (modal !== this.modal) return;
      if (this.lastTrigger) this.lastTrigger.focus({ preventScroll: true });
      this.lastTrigger = null;
    }
  }

  customElements.define("how-it-works", HowItWorks);
}
